import { Box, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";

function Products() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <Container maxWidth="xl">
        <Box
          sx={{
            maxWidth: "1400px",
            padding: { xs: "65px 0px 107px", lg: "140px 0px" },
            margin: "auto",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              color: "#000",
              fontWeight: 700,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 36, lg: 54 },
              lineHeight: { xs: "44px", lg: "65px" },
              maxWidth: "800px",
              margin: { xs: "auto", lg: 0 },
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            Products and Commodities
          </Typography>
          <br />
          <br />
          <Typography
            sx={{
              color: "#000",
              fontWeight: 500,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 28, lg: 40 },
              lineHeight: { xs: "44px", lg: "65px" },
              maxWidth: "800px",
              margin: { xs: "auto", lg: 0 },
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            What is Charget? (Electricity Token)
            <br />
          </Typography>
          <Typography
            sx={{
              color: "#000",
              fontWeight: 400,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 18, lg: 22 },
              padding: "24px 0px 20px",
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            Charget is Povego's innovative product that tokenizes electricity generation and consumption. Charget, the electricity tokenization of the energy sector, makes it easier for users to invest in the energy sector and makes energy trading more accessible. With Charget, you can both support sustainable energy projects and take your place in the energy market of the future. Thanks to Charget, which is the tokenized form of electricity used in automobile charging stations, individuals and institutions can control their expenses today to avoid being affected by possible increases in electricity prices in the future period or generate income from the increase in electricity prices.
            <br /><br />

            <strong>Why Electricity Token?</strong><br /><br />
            The electricity sector is one of the cornerstones of economic growth and sustainable development. Electricity tokens transform electricity generation, distribution, and consumption processes by offering innovative solutions in this sector. Here are some key reasons why electricity tokens are important:
            <br /><br />
            • Transparency and Traceability: Blockchain technology ensures that all processes from electricity generation to consumption are transparent and traceable, thus increasing trust in the electricity market.<br /><br />
            • Efficiency Increase: Electricity tokens enable trading to take place faster and more cost-effectively, increasing efficiency by reducing the need for intermediaries.<br /><br />
            • Renewable Energy Incentive: These tokens allow renewable energy projects such as solar and wind to be financed more easily and reach wider audiences.<br /><br />
            • Flexibility and Scalability: Electricity tokens support the participation of small-scale producers in the market and decentralized energy production.<br /><br />
            • Low Carbon Footprint: Tokenized electricity markets offer more effective solutions to reduce carbon emissions.<br /><br />
            • Global Access: Electricity produced in different regions can be traded worldwide thanks to tokens, ensuring that the electricity supply is more balanced and sustainable.<br /><br />

            <strong>Reasons Behind Rising Electricity Demand</strong><br /><br />
            Electricity demand is constantly increasing in line with the requirements of modern life. Here are the main reasons behind this demand:
            <br /><br />
            • Population Growth: Increasing population increases electricity consumption along with housing and service demand.<br /><br />
            • Urbanization: Migration to cities leads to more electricity usage in industrial and commercial sectors.<br /><br />
            • Technological Developments: New technologies such as electric vehicles and smart systems increase energy consumption.<br /><br />
            • Industrialization: Developing industrial activities require large amounts of electricity.<br /><br />
            • Rising Living Standards: The use of more electrical appliances increases energy demand.<br /><br />
            • Digitalization: Computers and data centers consume an ever-increasing amount of electricity.<br /><br />
            • Integration of Renewable Energy Sources: Renewable energy sources increase energy storage and grid management requirements.<br /><br />
            • Climate Change: Rising temperatures and extreme weather conditions increase the use of cooling systems and energy demand.<br /><br />

            <strong>Why is Demand for Electricity Tokens Increasing?</strong><br /><br />
            Demand for electricity tokens is increasing rapidly due to the innovative solutions they offer in the energy sector. The fact that all processes from electricity generation to consumption become transparent and traceable thanks to blockchain technology increases trust and prevents fraudulent activities. These tokens ensure that energy trading takes place faster and more cost-effectively, increasing efficiency by reducing the need for intermediaries.<br /><br />
            Furthermore, electricity tokens encourage easier financing of renewable energy projects and their reach to wider audiences. It supports energy production gaining a decentralized structure by enabling small-scale producers to participate in the market. Tokenized electricity markets offer more effective solutions to reduce carbon emissions and make energy trading global. For these reasons, the demand for electricity tokens is gradually increasing.
          </Typography>

          <Typography
            sx={{
              color: "#000",
              fontWeight: 500,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 28, lg: 40 },
              lineHeight: { xs: "44px", lg: "65px" },
              maxWidth: "800px",
              margin: { xs: "auto", lg: 0 },
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            What is PovCacao?
            <br />
          </Typography>
          <Typography
            sx={{
              color: "#000",
              fontWeight: 400,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 18, lg: 22 },
              padding: "24px 0px 20px",
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            Tokenized cocoa is the process of representing agricultural assets through digital tokens. With this innovative approach, Povego allows investors to invest in cocoa assets digitally and securely. Cocoa products are stored in secure and audited warehouses and offered to investors through digital tokens. These tokens provide the opportunity to benefit from value fluctuations in the cocoa market and offer the chance to earn earnings over cocoa, a valuable agricultural product on a global scale. In short, tokenized cocoa with Povego is a modern, reliable, and transparent way to invest in the agricultural sector.<br /><br />

            <strong>Why Cocoa?</strong><br /><br />
            Cocoa is one of the products with the highest trading volume among agricultural commodities, and each cocoa token represents a certain amount of cocoa. The rapid rise of the chocolate industry in recent years and increasing global demands have put cocoa among the most preferred commodities.<br /><br />
            Cocoa, the main component of chocolate, one of the world's most loved and consumed sweets, is an important commodity in financial markets beyond being just a delicious ingredient. Obtained from the seeds of the Theobroma cacao tree, cocoa has turned into a valuable product seeing great demand worldwide.<br /><br />

            <strong>The Power Behind Cocoa Demand</strong><br /><br />
            In 2021, the size of the global chocolate market was calculated as approximately 113.16 billion USD. In the 2022-2030 period, the demand for cocoa commodity will continue to increase with a growth rate of 3.7% and will further solidify its place among agricultural commodities. This growth is supported by increasing global chocolate consumption and expanding demand, especially in the Asian market. Increasing interest in chocolate products in emerging markets contributes to the continuous rise in cocoa demand. Additionally, healthy living trends and increasing awareness towards quality cocoa products positively affect cocoa prices and demand. This situation offers profitable opportunities for cocoa producers and investors in the long run. Cocoa prices, which were at the level of 2,000 dollars per ton in 2022, saw over 12,000 dollars in April 2024.<br /><br />

            <strong>Why Are Cocoa Prices Rising?</strong><br /><br />
            Behind the rise in cocoa prices are climate conditions and economic factors. Ivory Coast and Ghana, which realize 60% of the world's cocoa production, became unable to bear fruit as cocoa plants were damaged due to excessive rainfall. The Ghana government's announcement that it could not pay farmers resulted in producers not wanting to sell their products. Independent traders bought stocks by offering higher prices to farmers. As this situation reflected on Forex markets, cocoa prices rose, and investor interest increased, which caused prices to rise even further.
          </Typography>

          <Typography
            sx={{
              color: "#000",
              fontWeight: 500,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 28, lg: 40 },
              lineHeight: { xs: "44px", lg: "65px" },
              maxWidth: "800px",
              margin: { xs: "auto", lg: 0 },
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            What is PovNut?
            <br />
          </Typography>
          <Typography
            sx={{
              color: "#000",
              fontWeight: 400,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 18, lg: 22 },
              padding: "24px 0px 20px",
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            PovNut is a blockchain token that brings an innovative approach to the hazelnut sector. This token aims to make hazelnut production, trade, and consumption more transparent and efficient by digitizing them. Povego Hazelnut tokens reduce costs and speed up transactions by reducing the need for intermediaries in hazelnut trade.<br /><br />
            Moreover, it is backed by physical hazelnuts and is based on physical assets as a token indexed to the price of a kilogram of hazelnuts. In other words, these tokens are collateralized by physical hazelnuts stored in internationally audited warehouses. In this way, PovNut holders can be sure that their investments are secured by real hazelnut assets.<br /><br />

            <strong>Why Hazelnut Token?</strong><br /><br />
            Today, the financing of agricultural commodity production, consumption, and trade is gaining more importance than ever in the global crisis world we are in. Hazelnut has a strategic importance in trade between countries among these agricultural products. Hazelnut, which draws attention especially with its nutritional values and versatile use, increases its popularity among consumers along with healthy living trends.<br /><br />
            From an economic perspective, hazelnut production and trade constitute an important source of income for producer countries. Countries leading in hazelnut production such as Türkiye, Italy, and the USA play a major role in the trade of this strategic product. The increasing demand for hazelnuts worldwide also contributes to the economic growth of these countries.<br /><br />
            The digitization of hazelnut trade and its integration with financial markets increases efficiency in the sector. While blockchain-based solutions ensure that hazelnut trade is more transparent and traceable, they speed up transactions by reducing costs. These innovative approaches offer new opportunities for hazelnut producers and investors.<br /><br />
            Therefore, Povego hazelnut tokens help manage the supply and demand balance better. Producers can protect themselves against price fluctuations occurring in the market and sell their products at the most appropriate time. This creates a more stable market environment for both producers and consumers.<br /><br />

            <strong>Reasons Behind Increasing Hazelnut Demand</strong><br /><br />
            Hazelnuts see an increasing demand worldwide. Various economic, health, and industrial factors lie behind this increase in demand. Here are the reasons for increasing hazelnut demand:<br /><br />
            • Healthy Nutrition Trends: The spread of healthy eating habits increases the demand for nutritious foods like hazelnuts. With high protein, vitamin, mineral, and healthy fat content, hazelnut is preferred as a healthy snack and food component.<br /><br />
            • Usage Increase in Food Industry: Hazelnuts are widely used in chocolate, ice cream, and other sweet products. Innovations and new product developments in the food industry increase hazelnut demand.<br /><br />
            • Global Market Expansion: The increase in export capacities of hazelnut producer countries and their entry into new markets increase global demand. Hazelnut consumption is increasing rapidly, especially in emerging markets such as Asia and the Middle East.<br /><br />
            • Industrialization and Production Capacity: Industrialization and technological advancements increase hazelnut production capacity. Modern agricultural techniques provide more efficient and quality production, which supports demand.<br /><br />
            • Financial Instruments and Tokenization: Hazelnut tokens help manage the supply and demand balance. Producers can sell their products at the most appropriate time by being protected against price fluctuations. Tokenization increases investor interest by making trade transparent, efficient, and accessible.<br /><br />
            • Climate Change and Production Conditions: While climate change makes production difficult in some regions, it encourages production in regions with suitable climate conditions. The improvement of production conditions supports the demand increase by securing the hazelnut supply.<br />
          </Typography>

          <Typography
            sx={{
              color: "#000",
              fontWeight: 500,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 28, lg: 40 },
              lineHeight: { xs: "44px", lg: "65px" },
              maxWidth: "800px",
              margin: { xs: "auto", lg: 0 },
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            Products to be Added Soon
            <br />
          </Typography>
          <Typography
            sx={{
              color: "#000",
              fontWeight: 400,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 18, lg: 22 },
              padding: "24px 0px 60px",
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            • Peanut<br /><br />
            • Coffee<br /><br />
            • Oil (Petroleum)<br /><br />
            • Silver<br /><br />
            • Copper<br /><br />
            • Gold<br /><br />
            • Barley<br /><br />
            • Wheat<br /><br />
            • Sugar<br /><br />

            <strong>Povego's Mission and Vision</strong><br /><br />
            Our Mission: We act with the mission of presenting crypto assets on the blockchain to investors with a secure and innovative investment ecosystem.<br /><br />
            Our Vision: As Türkiye's blockchain-based investment platform, we aim to carry our pioneering role in the investment world of the future to the global arena.<br /><br />
          </Typography>
        </Box>
      </Container>
    </React.Fragment>
  );
}

export default Products;
